module.exports = __webpack_public_path__ + "static/media/logo.178fd57b.png";